import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import { goldFDHistoryApi } from "../redux/features/goldFD/goldFDHistorySlice";
import { historyApi } from "../redux/features/historySlice";
import "./history.css";

const History = () => {
  const [showGoldFD, setShowGoldFD] = useState(false);
  const sliceLoading = useSelector((state) => state?.historySlice?.status);
  const sliceResponse = useSelector((state) => state?.historySlice?.data);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // State variables for filtering
  const [filter, setFilter] = useState("all"); // Default filter
  const [filteredUserList, setFilteredUserList] = useState([]);

  const [activeFDFilter, setActiveFDFilter] = useState("active");

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    const currentDate = new Date();
    const endDateFormatted = formatDate(currentDate);

    const startDateObj = new Date(currentDate);
    startDateObj.setMonth(currentDate.getMonth() - 3);
    const startDateFormatted = formatDate(startDateObj);

    const payload = {
      endDate: endDateFormatted,
      startDate: startDateFormatted,
    };

    dispatch(historyApi(payload));
  }, [dispatch]);

  useEffect(() => {
    setFilteredUserList(sliceResponse?.data || []);
  }, [sliceResponse?.data]);

  // Filtered list effect
  useEffect(() => {
    if (filter === "all") {
      setFilteredUserList(sliceResponse?.data || []);
    } else {
      setFilteredUserList(
        (sliceResponse?.data || []).filter((item) => item.metalType === filter)
      );
    }
  }, [filter]);

  const handleFilterChange = (type) => {
    if (type == "all" || type == "gold" || type == "silver") {
      setShowGoldFD(false);
      setFilter(type);
    }

    if (type == "active") {
      setShowGoldFD(true);
      setFilter(type);
      setActiveFDFilter("active");
      dispatch(goldFDHistoryApi(type));
    }
  };

  const sendDataToInvoice = (item) => {
    // const stateData =
    //   item.type === "SPOT GOLD"
    //     ? {
    //         spotGoldId: item.transactionId,
    //         type: item.type,
    //         totalAmt: item.totalAmount,
    //       }
    //     : { item, type: item.type || "fd" };

    // navigate("/dashboard/historyinvoice", {
    //   state: stateData,
    // });

    navigate(`/dashboard/history/${item?.transactionId}`, {
      state: {
        item,
        type: item.type,
        totalAmt: item.totalAmount,
        isGold: item?.metalType == "gold" ? true : false,
      },
    });
  };

  const getGoldFDHistory = (status) => {
    setActiveFDFilter(status); // Update active filter state for FD
    dispatch(goldFDHistoryApi(status));
  };

  const fdResponse = useSelector((state) => state.goldFDHistorySlice.data.data);
  // useEffect(() => {
  //   dispatch(goldFDHistoryApi("active"));
  //   dispatch(goldFDHistoryApi("close"));
  // }, []);

  return (
    <main className="main_container">
      {/* ==BUTTONS=========== */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div
          id="myBtnContainer"
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <Button
              variant={filter === "all" ? "contained" : "outlined"}
              onClick={() => handleFilterChange("all")}
              sx={{
                backgroundColor: filter === "all" ? "#DA2128" : "transparent",
                color: filter === "all" ? "white" : "#DA2128",
                borderColor: filter === "all" ? "transparent" : "#DA2128",
                "&:hover": {
                  backgroundColor: "#DA2128",
                  color: "white",
                  border: "#DA2128",
                },
              }}
            >
              All
            </Button>

            <Button
              variant={filter === "gold" ? "contained" : "outlined"}
              onClick={() => handleFilterChange("gold")}
              sx={{
                backgroundColor: filter === "gold" ? "#DA2128" : "transparent",
                color: filter === "gold" ? "white" : "#DA2128",
                borderColor: filter === "gold" ? "transparent" : "#DA2128",
                "&:hover": {
                  backgroundColor: "#DA2128",
                  color: "white",
                  border: "#DA2128",
                },
              }}
            >
              Gold
            </Button>

            <Button
              variant={filter === "silver" ? "contained" : "outlined"}
              onClick={() => handleFilterChange("silver")}
              sx={{
                backgroundColor:
                  filter === "silver" ? "#DA2128" : "transparent",
                color: filter === "silver" ? "white" : "#DA2128",
                borderColor: filter === "silver" ? "transparent" : "#DA2128",
                "&:hover": {
                  backgroundColor: "#DA2128",
                  color: "white",
                  border: "#DA2128",
                },
              }}
            >
              Silver
            </Button>

            {/* <Button
              variant={filter == "active" ? "contained" : "outlined"}
              onClick={() => handleFilterChange("active")}
              sx={{
                backgroundColor:
                  filter === "active" ? "#472878" : "transparent",
                color: filter === "active" ? "white" : "#472878",
                borderColor: filter === "active" ? "transparent" : "#472878",
                "&:hover": {
                  backgroundColor: "#472878",
                  color: "white",
                },
              }}
            >
              Gold FD
            </Button> */}
          </div>

          {showGoldFD && (
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <Button
                variant={activeFDFilter == "active" ? "contained" : "outlined"}
                onClick={() => getGoldFDHistory("active")}
                sx={{
                  backgroundColor:
                    activeFDFilter === "active" ? "#472878" : "transparent",
                  color: activeFDFilter === "active" ? "white" : "#472878",
                  borderColor:
                    activeFDFilter === "active" ? "transparent" : "#472878",
                  "&:hover": {
                    backgroundColor: "#472878",
                    color: "white",
                  },
                }}
              >
                Active
              </Button>

              <Button
                variant={activeFDFilter == "close" ? "contained" : "outlined"}
                onClick={() => getGoldFDHistory("close")}
                sx={{
                  backgroundColor:
                    activeFDFilter === "close" ? "#472878" : "transparent",
                  color: activeFDFilter === "close" ? "white" : "#472878",
                  borderColor:
                    activeFDFilter === "close" ? "transparent" : "#472878",
                  "&:hover": {
                    backgroundColor: "#472878",
                    color: "white",
                  },
                }}
              >
                Close
              </Button>
            </div>
          )}
        </div>
      </div>

      {!showGoldFD && (
        <>
          {sliceLoading == "loading" ? (
            <div style={{ height: "70vh" }}>
              <Loader />
            </div>
          ) : filteredUserList?.length > 0 ? (
            filteredUserList.map((item, index) => (
              <div
                key={index}
                onClick={() => sendDataToInvoice(item)}
                className="card p-2 history_card"
              >
                <div className="history_card_inner">
                  {/* IMG======== */}
                  <div>
                    <img
                      src={
                        item?.company === "augmont"
                          ? item.metalType === "gold"
                            ? "/images/gold_shield.png"
                            : "/images/silver_shield.png"
                          : "/images/mmtc_logo.png"
                      }
                      alt="historyImg"
                      // style={{ width: 45 }}
                      className="history_logo"
                    />
                  </div>
                  {/* DATA======= */}
                  <div style={{ width: "100%" }}>
                    {item?.ProductName ? (
                      <div style={{ display: "flex", fontWeight: "bold" }}>
                        {item?.ProductName?.map((productName, index) => (
                          <React.Fragment key={index}>
                            {productName?.name || productName?.productName}
                            &nbsp; &nbsp;
                          </React.Fragment>
                        ))}
                      </div>
                    ) : (
                      <div style={{ fontWeight: "600" }}>{item.type}</div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div>
                        ₹{item.totalAmount}
                        <div>
                          {new Date(item.createdAt).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            }
                          )}
                        </div>
                      </div>
                      {/* STATUS===== */}
                      <div
                        style={{
                          fontWeight: "bold",
                          color: item.status === "cancelled" ? "red" : "green",
                          textTransform: "uppercase",
                          alignContent: "end",
                        }}
                      >
                        {item.status}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-dark text-center">
              <img
                src="/images/history-not-found.png"
                className="noHistoryFound p-2"
                alt="No History"
              />
              <h6>No History Found</h6>
              <p>Fill this Space with your Order</p>
            </div>
          )}
        </>
      )}

      {/* {showGoldFD && (
        <>
          {sliceLoading == "loading" ? (
            <Loader />
          ) : fdResponse?.length > 0 ? (
            fdResponse.map((item, index) => (
              <div key={index} className="text-decoration-none mb-4">
                <div
                  onClick={() => sendDataToInvoice(item)}
                  className="text-decoration-none newItem"
                >
                  <div
                    className="card p-2 mb-2"
                    style={{
                      boxShadow: "1px 3px 5px 0px rgba(0, 0, 0, 0.6)",
                    }}
                    // style={{border:"2px solid gold"}}
                  >
                    <div
                      style={{
                        width: "100%",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <div>
                        <div>{item.schemaName}</div>
                        <div>{item.jewellerUserAccountName}</div>
                      </div>
                      <div>
                        <div>Start Date: {item.startDate}</div>
                        <div>End Date: {item.endDate}</div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          fontSize: "18px",
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          color: item.status === "close" ? "red" : "green",
                        }}
                      >
                        {item.status}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-dark text-center">
              <img
                src="/images/history-not-found.png"
                className="noHistoryFound p-2"
                alt="No History"
              />
              <h6>No History Found</h6>
              <p>Fill this Space with your Order</p>
            </div>
          )}
        </>
      )} */}
    </main>
  );
};

export default History;
